import { Phone, Mail, Instagram, MapPin, ExternalLink } from "lucide-react";
import { CONTACT, PARTNERS } from "../data/site";

export const Footer = () => (
  <footer className="bg-[#2E2E2C] px-6 py-16 text-[#F7F4EE] sm:px-8 lg:px-12" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 md:grid-cols-3">
      <div>
        <p className="font-hand text-3xl text-[#8A9B87]">Hengähdys</p>
        <p className="mt-3 text-sm text-[#F7F4EE]/60 leading-relaxed">
          Juhlatila, kokoustila ja saunatila Porvoossa — tilavuokraus Vanhan kaupungin kupeessa.
        </p>
      </div>

      <div>
        <h2 className="text-sm uppercase tracking-[0.16em] text-[#F7F4EE]/50">Yhteystiedot</h2>
        <p className="mt-4 text-base">{CONTACT.name}</p>
        <a
          href={CONTACT.phoneHref}
          data-testid="footer-phone"
          className="mt-3 flex items-center gap-2 text-sm text-[#F7F4EE]/75 transition-colors hover:text-[#8A9B87]"
        >
          <Phone size={16} strokeWidth={1.6} /> p. {CONTACT.phone}
        </a>
        <a
          href={`mailto:${CONTACT.email}`}
          data-testid="footer-email"
          className="mt-2 flex items-center gap-2 text-sm text-[#F7F4EE]/75 transition-colors hover:text-[#8A9B87]"
        >
          <Mail size={16} strokeWidth={1.6} /> {CONTACT.email}
        </a>
        <a
          href={CONTACT.instagram}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram"
          className="mt-2 flex items-center gap-2 text-sm text-[#F7F4EE]/75 transition-colors hover:text-[#8A9B87]"
        >
          <Instagram size={16} strokeWidth={1.6} /> {CONTACT.instagramHandle}
        </a>
      </div>

      <div>
        <h2 className="text-sm uppercase tracking-[0.16em] text-[#F7F4EE]/50">Osoite</h2>
        <p className="mt-4 flex gap-2 text-sm text-[#F7F4EE]/75">
          <MapPin size={16} strokeWidth={1.6} className="mt-0.5 shrink-0" />
          {CONTACT.address}
        </p>
        <h2 className="mt-8 text-sm uppercase tracking-[0.16em] text-[#F7F4EE]/50">Yhteistyössä</h2>
        <div className="mt-4 flex flex-col items-start gap-2">
          {PARTNERS.map((p, i) => (
            <a
              key={p.url}
              href={p.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`footer-partner-${i}`}
              className="inline-flex items-center gap-2 text-sm text-[#F7F4EE]/75 transition-colors hover:text-[#8A9B87]"
            >
              <ExternalLink size={16} strokeWidth={1.6} /> {p.name}
            </a>
          ))}
        </div>
      </div>
    </div>

    <div className="mx-auto mt-14 flex max-w-7xl flex-wrap items-center justify-between gap-4 border-t border-[#F7F4EE]/10 pt-6 text-xs text-[#F7F4EE]/45">
      <span>© {new Date().getFullYear()} Hengähdys — Sauna ja Tila</span>
      <a
        href="https://myyntidrive.fi"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="footer-credit"
        className="transition-colors hover:text-[#8A9B87]"
      >
        Toteutus: MyyntiDrive
      </a>
    </div>
  </footer>
);
